import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment-timezone';

import classNames from './../utils/classNames';
import formatTime from './../utils/formatTime';

import { ordersProgressFetchIfNeeded, ordersProgressSetSorting } from './../store/ordersProgress/actions';
import { getOrdersProgressSorted } from './../store/ordersProgress/selectors';
import { getOrderIdsWithUnreadMessages } from './../store/notification/selectors';

import { StickyContainer, StickyHead, StickyBody } from './Sticky';
import Icon from './Icon';
import Emoji from './Emoji';
import TableSortingHead from './TableSortingHead';
import UpToButton from './UpToButton';

const COUNT_STEP = 20;

class OrdersProgressTable extends Component {
    constructor(props) {
        super(props);

        this.state = {
            count: COUNT_STEP
        }

        this.onMoreClick = this.onMoreClick.bind(this);
    }

    componentDidMount() {
        const { loadOrders } = this.props;
        loadOrders();
    }

    onMoreClick() {
        const { orderList } = this.props;
        this.setState(state => Object.assign({}, state, {
            count: Math.min(state.count + COUNT_STEP, orderList.length)
        }));
    }

    renderDeadline(order) {
        const hoursDiff = Math.round(moment().diff(moment(order.pregrader_created_at), 'hours', true));
        const className = classNames({ 'text-warning': hoursDiff > 72 })
        return (
            <span>
                {formatTime(order.pregrader_deadline, 'dt') + ' / '}
                <span className={className}>{formatTime(order.pregrader_created_at, 'hms_tn')}</span>
            </span>
        );
    }

    hasUnread(orderId) {
        const { unreadOrderIds } = this.props;
        return unreadOrderIds.indexOf(orderId) > -1;
    }

    renderRow(order) {
        const { onSelect, selectedNumber } = this.props;
        const className = classNames('table-row row vertical', { 'active': selectedNumber === order.number });
        const pregrader_price = !!order.pregrader_price ? order.pregrader_price.toFixed(2) : '';

        return (
            <div className={className} key={order._id} onClick={() => onSelect(order.number)}>
                <div className="col-4">
                    {order.number}
                    <a href={`/order/${order._id}`} target="_blank" rel="noopener noreferrer">
                        <Icon className="svg-icon" iconName="open-new-window" />
                    </a>
                </div>
                <div className="col-3">{order.subject}</div>
                <div className="col-3">{order.type}</div>
                <div className="col-2">{pregrader_price}</div>
                <div className="col-2">{order.size}</div>
                <div className="col-4">{this.renderDeadline(order)}</div>
                <div className="col-2 ta-center">
                    {this.hasUnread(order._id) &&
                        <Icon className="svg-icon" iconName="email-notification" />
                    }
                </div>
            </div>
        );
    }

    renderOrderList() {
        const { orderList, isLoading } = this.props;
        const { count } = this.state;

        if (isLoading) {
            return (<div className="preloading preloading-box"><p>Loading</p></div>);
        }

        if (!orderList.length) {
            return (
                <div className="page-not-result">
                    <Emoji id="crySad" />
                    <h1>Oops, there are no orders in this section.</h1>
                    <p className="notes">Only accepted orders are shown here.</p>
                </div>
            );
        }

        return orderList.slice(0, count).map(order => this.renderRow(order));
    }

    renderNextButton() {
        const { orderList, isLoading } = this.props;

        if (!orderList.length || isLoading) {
            return null;
        }

        const { count } = this.state;
        const nextCount = Math.min(orderList.length - count, COUNT_STEP);
        if (nextCount <= 0) {
            return null;
        }
        return (
            <button type="button" className="btn btn-show-next" onClick={this.onMoreClick}>Show next {nextCount} orders</button>
        );
    }

    render() {
        const { setSorting, sorting } = this.props;
        return (
            <div className="table orders-table">
                <StickyContainer className="sticky-table">
                    <StickyHead className="sticky-table-head" classNameFixed="sticky-table-head-fixed">
                        <div className="table-header">
                            <div className="row vertical">
                                <div className="col-4">Order Number</div>
                                <div className="col-3">Subject</div>
                                <div className="col-3">Type of work</div>
                                <div className="col-2">
                                    <TableSortingHead sorting={sorting} setSorting={setSorting} field="pregrader_price">Your price</TableSortingHead>
                                </div>
                                <div className="col-2">
                                    <TableSortingHead sorting={sorting} setSorting={setSorting} field="pages">Size</TableSortingHead>
                                </div>
                                <div className="col-4">
                                    <TableSortingHead sorting={sorting} setSorting={setSorting} field="pregrader_deadline">Deadline/TIP</TableSortingHead>
                                </div>
                                <div className="col-2 ta-center">
                                    <TableSortingHead sorting={sorting} setSorting={setSorting} field="messagesComputed">Messages</TableSortingHead>
                                </div>
                            </div>
                        </div>
                    </StickyHead>
                    <StickyBody className="sticky-table-body">
                        {this.renderOrderList()}
                    </StickyBody>
                </StickyContainer>
                <UpToButton />
                {this.renderNextButton()}
            </div>
        );
    }
}

const mapStateToProps = state => {
    const orders = state.ordersProgress;
    return {
        isLoading: orders.isFetching,
        orderList: getOrdersProgressSorted(state),
        sorting: orders.sorting,
        unreadOrderIds: getOrderIdsWithUnreadMessages(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadOrders: () => dispatch(ordersProgressFetchIfNeeded()),
        setSorting: value => dispatch(ordersProgressSetSorting(value))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrdersProgressTable);



// WEBPACK FOOTER //
// ./src/components/OrdersProgressTable.js